import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import Navigation from "../components/layout/Navigation";
import Footer from "../components/layout/Footer";
import AIAssistant from "../components/admin/AIAssistant";
import { Bot, Sparkles, FileText, Hash, Lightbulb, ShoppingBag } from "lucide-react";

const AIAssistantPage = () => {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!user || user.role !== "admin") {
      navigate("/login");
    }
  }, [user, navigate]);
  
  if (!user || user.role !== "admin") {
    return null;
  }
  
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navigation />
      
      <main className="flex-1 container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-3 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl">
              <Bot className="h-8 w-8 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold">AI Sales & Marketing Assistant</h1>
              <p className="text-muted-foreground">
                Your expert companion for First Nations art and fashion marketing
              </p>
            </div>
          </div>
        </div>
        
        {/* Capabilities Banner */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
          <div className="p-4 bg-purple-50 border border-purple-200 rounded-lg text-center">
            <Sparkles className="h-6 w-6 text-purple-600 mx-auto mb-2" />
            <p className="text-sm font-medium text-purple-800">Caption Generator</p>
          </div>
          <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg text-center">
            <FileText className="h-6 w-6 text-blue-600 mx-auto mb-2" />
            <p className="text-sm font-medium text-blue-800">Art Descriptions</p>
          </div>
          <div className="p-4 bg-green-50 border border-green-200 rounded-lg text-center">
            <ShoppingBag className="h-6 w-6 text-green-600 mx-auto mb-2" />
            <p className="text-sm font-medium text-green-800">Sales Copy</p>
          </div>
          <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg text-center">
            <Lightbulb className="h-6 w-6 text-yellow-600 mx-auto mb-2" />
            <p className="text-sm font-medium text-yellow-800">Content Ideas</p>
          </div>
          <div className="p-4 bg-pink-50 border border-pink-200 rounded-lg text-center">
            <Hash className="h-6 w-6 text-pink-600 mx-auto mb-2" />
            <p className="text-sm font-medium text-pink-800">Hashtag Generator</p>
          </div>
        </div>
        
        {/* Main Chat Area */}
        <div className="bg-white border rounded-xl shadow-sm p-6">
          <AIAssistant token={token} />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default AIAssistantPage;
